import React from 'react';

interface TabPanelProps {
  id?: string;
  role?: string;
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...rest
}) => (
  <div hidden={value !== index} {...rest}>
    {children}
  </div>
);

export default TabPanel;
